import { Link } from "react-router-dom";
import { RotateCcw, ArrowLeft } from "lucide-react";

// Shared completion card for all three games: same tone-mapped card shell
// as AcademyQuiz.jsx's FinishedCard, so a finished game feels consistent
// with a finished Academy quiz.
const TONE_CLS = {
  emerald: "bg-emerald-50 border-emerald-200 text-emerald-900",
  sky: "bg-sky-50 border-sky-200 text-sky-900",
  amber: "bg-amber-50 border-amber-200 text-amber-900",
};

export default function GameResultCard({
  icon: Icon,
  tone = "emerald",
  eyebrow,
  headline,
  scoreText,
  subtext,
  onReplay,
  replayLabel = "Play again",
  children,
}) {
  return (
    <div className="space-y-5" data-testid="game-result-card">
      <div className={`rounded-2xl border-2 p-6 sm:p-8 ${TONE_CLS[tone] || TONE_CLS.emerald}`}>
        <div className="flex items-center gap-3">
          {Icon && <Icon className="w-7 h-7" aria-hidden="true" />}
          <div className="text-xs uppercase tracking-[0.18em] font-semibold">{eyebrow}</div>
        </div>
        <div className="mt-2 font-display text-3xl sm:text-4xl font-semibold" data-testid="game-result-headline">
          {headline}
        </div>
        {scoreText && (
          <div className="mt-1 text-sm" data-testid="game-result-score">{scoreText}</div>
        )}
        {subtext && <p className="mt-2 text-sm">{subtext}</p>}
      </div>

      {children}

      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={onReplay}
          data-testid="game-result-replay"
          className="min-h-11 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-[#1B4332] text-white font-medium text-sm hover:bg-[#143027]"
        >
          <RotateCcw className="w-4 h-4" /> {replayLabel}
        </button>
        <Link
          to="/academy/games"
          data-testid="game-result-back"
          className="min-h-11 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border border-slate-300 bg-white text-slate-800 font-medium text-sm hover:bg-slate-50"
        >
          <ArrowLeft className="w-4 h-4" /> More games
        </Link>
      </div>
    </div>
  );
}
